export { SORT_TYPES } from './sortTypes';

export const PAYMENTS_COLUMNS = [
  { id: 'date', label: 'Date', alwaysVisible: true, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'payment_method', label: 'Payment Method', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'payment_count', label: 'Payments', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'payments', label: 'Received', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'currency' },
  { id: 'refunds', label: 'Refunded', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'currency' },
  { id: 'amount', label: 'Net', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'ticket_revenue', label: 'Ticket Revenue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'fees', label: 'Fees', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'tax', label: 'Tax', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'donation', label: 'Donation', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'merchandise', label: 'Merchandise', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'other', label: 'Other', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'currency' },
];

export const MONEY_COLUMN_IDS = ['payments', 'refunds', 'amount', 'ticket_revenue', 'fees', 'tax', 'donation', 'merchandise', 'other'];

export const getDefaultVisibleColumns = () => PAYMENTS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () => PAYMENTS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
